import styled from 'styled-components';

import BaseButton from 'components/b2c/Button';
import { getSpacing, colorUsage, letterSpacing } from 'stylesheetB2c';

interface BamButtonProps {
  light?: boolean;
  lighter?: boolean;
  disabled?: boolean;
}

export const BamButton = styled(BaseButton)<BamButtonProps>`
  letter-spacing: ${letterSpacing.medium};
  padding: ${getSpacing(1)} ${getSpacing(5)};
  color: ${colorUsage.whiteText};
  background-color: ${(props) => {
    if (props.disabled) return colorUsage.primaryButtonBackgroundDisabled;
    if (props.lighter || props.light) return colorUsage.lightButtonBackground;
    return colorUsage.primaryButtonBackground;
  }};
  border: ${(props) => (props.lighter ? `solid 1px ${colorUsage.lighterButtonBorder}` : 'none')};
  border-radius: ${getSpacing(7)};
  text-decoration: ${(props) => (props.light ? 'underline' : 'none')};
  :focus {
    outline: thin dotted;
  }
`;
